var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chart',{staticClass:"chart_zhaban",attrs:{"options":_vm.line},on:{"datazoom":function($event){return _vm.onDataZoom($event,_vm.line)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }